import React from "react";
import { useHistory } from "react-router";
import { Layout, Form, Input, Button, Row, Col } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useAuth } from "../../auth";

const { Content } = Layout;

const NormalLoginForm = () => {
  const [formLogin] = Form.useForm();
  let history = useHistory();
  let auth = useAuth();

  const onFinish = (values) => {
    let resolved = () => {
      history.push("/home");
    };
    let rejected = () => {
      formLogin.setFields([{
        name: 'username',
        errors: ['Les identifiants saisis ne correspondent pas']
      }, {
        name: 'password',
        value: null,
        errors: ['Les identifiants saisis ne correspondent pas']
      }]);
    };
    auth.signin(values, resolved, rejected);
  };

  return (
    <Content>
      <Form
        form={formLogin}
        name="normal_login"
        className="login-form"
        onFinish={onFinish}
      >
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: "Le nom d'utilisateur ne peut pas être vide",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Nom d'utilisateur"
          />
        </Form.Item>
        
        <Form.Item
          className="mb-2"
          name="password"
          rules={[
            {
              required: true,
              message: "Le password ne peut pas être vide",
            },
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Mot de passe"
          />
        </Form.Item>

        <Row>
          <Col span={24}>
            <Form.Item className="mt-0">
              <a className="login-form-forgot" href="/password/request"  style={{ float: 'right' }}>
                mot de pass oublié ?
              </a>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Connexion
          </Button>
        </Form.Item>
      </Form>
    </Content>
  );
};

export default NormalLoginForm;
